import React, { useMemo } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdOutlineBrandingWatermark,
	MdOutlineChecklist,
	MdOutlineComputer,
	MdOutlineLocalOffer,
	MdOutlineMonetizationOn,
	MdOutlineShoppingBag,
	MdOutlineStore,
} from "react-icons/md";
import { Link } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { TbShoppingCartDiscount } from "react-icons/tb";
import { useFilter } from "../../../../../../contexts/filterContext";
import { BiImport } from "react-icons/bi";
import { CONSTANTS } from "../../../../../../utils/constants";
import { COLORS } from "../../../../../layout/theme";

export default function ModuleMarketplace({
	clientContract,
	clientName,
	activeSection,
}) {
	const { setAdminUsersType } = useFilter();

	const generalItems = useMemo(
		() => [
			{
				to: "/homeMarketplace",
				title: "Marketplace",
				desc: "Vista principal del marketplace",
				icon: <MdOutlineComputer size={16} />,
			},
			{
				to: `/stores/${clientName}`,
				title: `Tienda ${clientName}`,
				desc: "Acceso directo a la tienda pública",
				icon: <MdOutlineStore size={16} />,
			},
			{
				to: "/admin/account?uri=generalConfig",
				title: "Cuenta",
				desc: "Configuración general de la cuenta",
				icon: <MdOutlineBrandingWatermark size={16} />,
			},
			{
				to: "/admin/users?uri=generalConfig",
				title: "Usuarios",
				desc: "Administración de usuarios web",
				icon: <UserOutlined style={{ fontSize: 16 }} />,
				onClick: () => setAdminUsersType(CONSTANTS.USERS_WEB),
			},
			{
				to: "/admin/laboratoryAuditory?uri=generalConfig",
				title: "Auditoría pedidos",
				desc: "Consulta y control de auditoría de pedidos",
				icon: <BiImport size={16} />,
			},
		],
		[clientName, setAdminUsersType],
	);

	const productsItems = useMemo(
		() => [
			{
				to: "/admin/items?uri=generalConfig",
				title: "Productos activos",
				desc: "Administración de productos vigentes",
				icon: <MdOutlineChecklist size={16} />,
			},
			{
				to: "/admin/prices?uri=generalConfig",
				title: "Ofertas marketplace",
				desc: "Gestión de ofertas y descuentos",
				icon: <TbShoppingCartDiscount size={16} />,
			},
		],
		[],
	);

	const publicityItems = useMemo(
		() => [
			{
				to: "/admin/store?uri=generalConfig",
				title: `Banners Tienda ${clientName}`,
				desc: "Configuración visual de la tienda",
				icon: <MdOutlineShoppingBag size={16} />,
			},
			{
				to: "/admin/bannerRequest?uri=generalConfig",
				title: "Banners Marketplace",
				desc: "Administración de banners generales",
				icon: <MdOutlineComputer size={16} />,
			},
			...(clientContract && clientContract.activeCouponSection
				? [
						{
							to: "/admin/laboratoryCoupons?uri=generalConfig",
							title: "Cupones",
							desc: "Gestión de cupones y promociones",
							icon: <MdOutlineLocalOffer size={16} />,
						},
					]
				: []),
		],
		[clientContract, clientName],
	);

	const panel =
		activeSection === "products"
			? {
					eyebrow: "Productos",
					title: "Gestión de Productos",
					desc: "Sección para administrar los productos del marketplace",
					icon: <MdOutlineChecklist size={20} />,
					iconBg: COLORS.LightSecondary, //"#E1F5EE",
					iconColor: COLORS.Secondary, //"#0F6E56",
					items: productsItems,
				}
			: activeSection === "publicity"
				? {
						eyebrow: "Publicidad",
						title: "Publicidad",
						desc: "Sección para administrar la publicidad de tu negocio",
						icon: <MdOutlineMonetizationOn size={20} />,
						iconBg: COLORS.LightDefault, //"#FAEEDA",
						iconColor: COLORS.Default, //"#854F0B",
						items: publicityItems,
					}
				: {
						eyebrow: "Configuración General",
						title: "Marketplace",
						desc: "Administra los datos y accesos principales del marketplace",
						icon: <MdOutlineComputer size={20} />,
						iconBg: "#E6F1FB",
						iconColor: "#185FA5",
						items: generalItems,
					};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						onClick={item.onClick}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
									{item.icon}
								</CardIconWrap>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
